<template>
  <div class="wrapper">
    <!-- 顶部 -->
    <Head />
    <!-- 主体 -->
    <div class="content-box">
      <el-scrollbar wrap-class="contentScrollbar" ref="myScrollbar">
        <div class="content">
          <transition name="move" mode="out-in">
            <keep-alive include="Home">
              <router-view></router-view>
            </keep-alive>
          </transition>
        </div>
      </el-scrollbar>
    </div>
    <!-- 客服 -->
    <Consult />
  </div>
</template>

<script>
import Head from "./components/Head.vue";
import Consult from "./components/Consult.vue";
export default {
  components: {
    Head,
    Consult,
  },
  data() {
    return {};
  },
  watch: {
    $route(to, from) {
      setTimeout(() => {
        this.$refs.myScrollbar.wrap.scrollTop = 0;
      }, 400);
    },
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.wrapper {
  background: #f1f5fc;
}
</style>
